import { CompanyLocationMaps } from "../sections/company-location";

function Maps() {
  return <CompanyLocationMaps />;
}

export default Maps;
